import PropTypes from 'prop-types'
import { TABLAS_LABELS, INDICADORES_LABELS } from '../../../common/constants/labels'
import { TIPO_ACCIDENTE_CHART, GRAVEDAD_CHART } from '../../../common/constants/charts'
import RankingDenuncias from './RankingDenuncias'
import Indicadores from './Indicadores'
import DonutChartSection from './DonutChartSection'
import ColumnChartSection from './ColumnChartSection'

export const GraficosTab = ({
  topRankingSiniestros,
  topRankingSiniestrosLoading,
  indicadores,
  indicadoresLoading,
  graficosTipoAccidente,
  graficosTipoAccidenteLoading,
  graficosGravedad,
  graficosGravedadLoading,
  graficosDenuncias,
  graficosDenunciasLoading,
  graficosDenunciasShouldRender,
}) => {
  return (
    <>
      <Indicadores title={INDICADORES_LABELS.TITLE} data={indicadores} isLoading={indicadoresLoading} />
      <div className="mt-6 rounded-md border border-tertiary-95 bg-white">
        <div className="relative grid grid-cols-1 xl:grid-cols-2">
          <div className="hidden xl:block absolute left-1/2 top-1/2 h-[338px] w-px -translate-x-1/2 -translate-y-1/2 bg-tertiary-95" />
          <div className="p-4 xl:p-6">
            <DonutChartSection
              chartConfig={TIPO_ACCIDENTE_CHART}
              data={graficosTipoAccidente.data}
              isLoading={graficosTipoAccidenteLoading}
            />
          </div>
          <div className="border-t border-tertiary-95 xl:border-t-0 p-4 xl:p-6">
            <DonutChartSection
              chartConfig={GRAVEDAD_CHART}
              data={graficosGravedad.data}
              isLoading={graficosGravedadLoading}
            />
          </div>
        </div>
      </div>
      {graficosDenunciasShouldRender && (
        <ColumnChartSection data={graficosDenuncias} isLoading={graficosDenunciasLoading} />
      )}
      <RankingDenuncias
        title={TABLAS_LABELS.TOP_RANKING_SINIESTROS}
        data={topRankingSiniestros}
        isLoading={topRankingSiniestrosLoading}
      />
    </>
  )
}

GraficosTab.propTypes = {
  topRankingSiniestros: PropTypes.array.isRequired,
  topRankingSiniestrosLoading: PropTypes.bool,
  indicadores: PropTypes.object.isRequired,
  indicadoresLoading: PropTypes.bool,
  graficosTipoAccidente: PropTypes.shape({
    total: PropTypes.number,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
        selected: PropTypes.bool,
      })
    ).isRequired,
  }).isRequired,
  graficosTipoAccidenteLoading: PropTypes.bool,
  graficosGravedad: PropTypes.shape({
    total: PropTypes.number,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
        selected: PropTypes.bool,
      })
    ).isRequired,
  }).isRequired,
  graficosGravedadLoading: PropTypes.bool,
  graficosDenuncias: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.number).isRequired,
      })
    ).isRequired,
  }).isRequired,
  graficosDenunciasLoading: PropTypes.bool,
  graficosDenunciasShouldRender: PropTypes.bool,
}
